import { FileReference } from '@kaizenplatform/belfast-entity';
import { ClassAttributes, createElement } from 'react';

import { DynamicSchemaDefinitionFiles } from '../../../../../graphql/generated/graphql';
import { EnhancedBatchDownload } from '../../../../connected/EnhancedBatchDownload';
import { FileListContainer } from '../../FileList';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionFiles, 'label'>;
  value: string | null;
  files: FileReference[];
  className?: string;
}

const AsFiles = ({ field, value, files, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      <FileListContainer files={files} />
      {files.length >= 2 && value != null ? <EnhancedBatchDownload bucketId={value} /> : null}
    </Base>
  );
};

export default AsFiles;
